<script>
    export let options;

    const quarters = [1,2,3,4];

</script>

<div class="col-md-1 mt-3 pr-0">
    <div class="dropdown" id="year-selector" >
        <button class="btn dropdown-toggle dropdown-date-selector" type="button" id="dropdownDate" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Q{options.month}
        </button>
        <div class="dropdown-menu mw-100" aria-labelledby="dropdownDate">
          {#each quarters as quarter}
             <a on:click={ () => options.month = quarter}
             href="/{options.menu.url}/{options.org.id}{(options.subMenu)?'/'+options.subMenu:''}/{options.year}/{quarter}"
             class="dropdown-item">
              Q{quarter}
            </a>
          {/each}
        </div>
    </div>
</div>
